

var _squid = require('squid');

var FIXED_SUMMARY_WIDTH_QUERY = '(min-width: 30em)';
var STICKY_SUMMARY_WIDTH_QUERY = '(max-width: 30em)';

function positionOrderSummary(scroll) {
    var orderSummary = $('#orderSummary');
    if (orderSummary) {
        orderSummary.css('transform', 'translateY(' + scroll + 'px)');
    }
}

// Clear the styles set in order to make the order summary fixed on side of page
function resetFixedSummary(_ref) {
    var orderSummary = _ref.orderSummary;

    orderSummary.css('transform', '');
}

// Set styles for order summary sticky to bottom of page for mobile
function setStickySummary(_ref2) {
    var cartContents = _ref2.cartContents,
        orderSummary = _ref2.orderSummary;

    var osHeight = orderSummary.outerHeight(true);

    cartContents.css('margin-bottom', osHeight + 'px');
    orderSummary.css({ position: 'fixed', bottom: 0 });
}

// Clear the styles set for order summary sticky to bottom of page for mobile
function resetStickySummary(_ref3) {
    var cartContents = _ref3.cartContents,
        orderSummary = _ref3.orderSummary;

    cartContents.css('margin-bottom', '');
    orderSummary.css({ position: '', bottom: '' });
}

function areAllItemsVisible() {
    var headerHeight = $('.header').prop('scrollHeight');
    var osHeight = $('#orderSummary').prop('scrollHeight');
    var itemsDivHeight = $('#items').prop('scrollHeight');
    var footerHeight = $('.footer').prop('scrollHeight');
    var windowInnerHeight = window.innerHeight;
    var availableSpaceForItems = windowInnerHeight - (headerHeight + osHeight + footerHeight);
    return availableSpaceForItems > itemsDivHeight;
}

function matchesMediaQuery(query) {
    if (!window.matchMedia) {
        return false;
    }

    return window.matchMedia(query).matches;
}

$.fn.isOnScreen = function () {
    if (!this.length) {
        return false;
    }

    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};

module.exports = {

    getEachItemMaxHeight: function getEachItemMaxHeight(cartItems, index) {
        var itemDetailsHeight = 0,
            itemNameHeight = 0,
            itemNumberHeight = 0;
        var itemDetails = $('#itemDetails' + index);
        var itemName = $('#item' + index + 'name');
        var itemNumber = $('#item' + index + 'number');
        var item = $('#item' + index);

        if (cartItems[index] && cartItems[index].details && itemDetails) {
            itemDetailsHeight = itemDetails.prop('scrollHeight'); // to accommodate details
        }

        if (itemName) {
            if (angular.element('#item' + index + 'name').hasClass('ellipsisEffect')) {
                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
                itemNameHeight = itemName.prop('scrollHeight');
                angular.element('#item' + index + 'name').addClass('ellipsisEffect');
            } else {
                itemNameHeight = itemName.prop('scrollHeight');
            }
        }
        if (itemNumber) {
            if (angular.element('#item' + index + 'number').hasClass('ellipsisEffect')) {
                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
                itemNumberHeight = itemNumber.prop('scrollHeight');
                angular.element('#item' + index + 'number').addClass('ellipsisEffect');
            } else {
                itemNumberHeight = itemNumber.prop('scrollHeight');
            }
        }
        return item.prop('scrollHeight') + itemDetailsHeight + itemNameHeight + itemNumberHeight;
    },

    getDetailsMaxHeight: function getDetailsMaxHeight(index) {
        return $('#itemDetails' + index).prop('scrollHeight');
    },

    getItemNameMaxHeight: function getItemNameMaxHeight(index) {
        return $('#item' + index + 'name').prop('scrollHeight');
    },

    getContainerColWidth: function getContainerColWidth() {
        return $('#itemProperties').width();
    },

    areAllItemsVisible: areAllItemsVisible,

    setOrderSummaryColor: function setOrderSummaryColor() {

        if (areAllItemsVisible()) {
            $('#orderSummaryHead').addClass('opaque');
            $('.details-expand').addClass('opaque');
        } else {
            $('#orderSummaryHead').removeClass('opaque');
            $('.details-expand').removeClass('opaque');
        }
    },

    loadJsButton: function loadJsButton($locale, checkoutType, localeInfo) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-merchant', 'PP_ADD_TO_CART');
        script.setAttribute('data-button', 'checkout');
        script.setAttribute('data-type', 'button');
        script.setAttribute('data-size', 'medium');
        script.setAttribute('data-lc', localeInfo);
        script.setAttribute('data-shape', 'pill');
        if (checkoutType === 'member') {
            script.setAttribute('data-color', 'gold');
        } else {
            script.setAttribute('data-color', 'silver');
            script.setAttribute('data-label', $locale.content.get('shoppingCart.checkoutOut'));
            script.setAttribute('data-tagline', 'false');
        }
        script.src = 'https://' + _squid.$meta.cdnHost + '/api/button.js';
        return script;
    },

    // Runs media query and returns result in javascript
    matchesMediaQuery: matchesMediaQuery,

    initWindowScrollActions: function initWindowScrollActions() {
        var cartContents = $('#cartContents');
        var orderSummary = $('#orderSummary');
        var elements = { cartContents: cartContents, orderSummary: orderSummary };

        // For large enough screens, make orderSummary in a "fixed" position within the cart contents
        var handleFixedSummary = function handleFixedSummary() {
            var scroll = $(window).scrollTop();
            var cartContentsHeight = cartContents.prop('scrollHeight');
            var osHeight = orderSummary.prop('scrollHeight');
            var scrollLimit = cartContentsHeight - osHeight - 25; // allow for padding

            if (!$('.footer').isOnScreen() && scroll < scrollLimit) {
                positionOrderSummary(scroll);
            } else {
                positionOrderSummary(0);
            }
        };

        // For a small screen, make orderSummary "sticky" positioned to bottom of the page
        var handleStickySummary = function handleStickySummary() {
            var viewportBottom = $(window).scrollTop() + $(window).height();
            // if offset is undefined , default to 0
            var offSet = cartContents.offset() && cartContents.offset().top || 0;
            var cartBottom = offSet + cartContents.height() + // height of cartContents without margins, since margin is used to fill space of the orderSummary when position fixed
            orderSummary.outerHeight(true);

            if (viewportBottom > cartBottom) {
                resetStickySummary(elements);
            } else {
                setStickySummary(elements);
            }
        };

        var handleWindowScroll = function handleWindowScroll() {
            if (matchesMediaQuery(FIXED_SUMMARY_WIDTH_QUERY)) {
                handleFixedSummary();
            } else {
                resetFixedSummary(elements);
            }

            if (matchesMediaQuery(STICKY_SUMMARY_WIDTH_QUERY)) {
                handleStickySummary();
            } else {
                resetStickySummary(elements);
            }
        };

        $(window).scroll(handleWindowScroll);
        handleWindowScroll();

        return function () {
            $(window).off('scroll', handleWindowScroll);
        };
    }
};

_squid.$meta;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/cartUiUtil.js
// module id = ./pages/xo-shoppingcart/cartUiUtil.js
// module chunks = 0